import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

import type { SearchResultData } from "../../@types/portalAluno";
import {
  isSearchable,
  searchContents,
} from "../../services/portalAluno/search/searchService";
import type { ApplicationState } from "../../store";

export const portalSearchQueryKey = (idUsuario?: number, query?: string) => [
  "portal-aluno",
  "pesquisa",
  idUsuario,
  query,
];

const useContentSearch = (query: string) => {
  const auth = useSelector((state: ApplicationState) => state.auth.data);
  const idUsuario = auth?.idUsuario;
  const trimmedQuery = query.trim();

  return useQuery<SearchResultData>({
    enabled: Boolean(idUsuario) && isSearchable(trimmedQuery),
    queryKey: portalSearchQueryKey(idUsuario, trimmedQuery),
    queryFn: () => searchContents(trimmedQuery),
    staleTime: 60 * 1000,
  });
};

export default useContentSearch;
